import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import "./Question12.css";
import AI1 from "./images/ai1.gif";
import AI2 from "./images/ai2.gif";
import Lightbulb from "./images/lightbulb.gif";
import Piechart from "./images/piechart.gif";
import Strategy from "./images/strategy.gif";
import Research from "./images/research.gif";
import Knowledge from "./images/knowledge.gif";
import Notebook from "./images/notebook.gif";
import Task from "./images/task.gif";
import Target from "./images/target.gif";
import Barchart from "./images/barchart.gif";

const Question12 = ({ onAnswer, userResponse }) => {
  const question = {
    title:
      "How likely are you to invest in a research workshop that could save you months of effort, using cutting-edge tools and strategies to transform your research approach?",
    questionImage1: AI1,
    questionImage2: AI2,
    questionImage3: Lightbulb,
    questionImage4: Piechart,
    questionImage5: Strategy,
    questionImage6: Research,
    questionImage7: Knowledge,
    questionImage8: Notebook,
    questionImage9: Task,
    questionImage10: Target,
    questionImage11: Barchart,
    options: [
      { label: "Extremely likely" },
      { label: "Likely" },
      { label: "Not sure" },
      { label: "Unlikely" },
    ],
  };

  const handleNext = () => {
    if (!userResponse[question.title]) {
      return;
    }
    setTimeout(() => {
      onAnswer(question.title, null);
    }, 1000);
  };

  return (
    <AnimatePresence>
      <motion.div
        className="question12-container"
        initial={{ opacity: 0, x: "20%" }}
        animate={{ opacity: 1, x: 0 }}
        exit={{ opacity: 0, x: "-100vw" }}
        transition={{ duration: 1 }}
      >
        {question.questionImage1 && (
          <img
            className="question12-img1"
            src={question.questionImage1}
            alt="Question"
          />
        )}
        {question.questionImage2 && (
          <img
            className="question12-img2"
            src={question.questionImage2}
            alt="Question"
          />
        )}
        {question.questionImage3 && (
          <img
            className="question12-img3"
            src={question.questionImage3}
            alt="Question"
          />
        )}
        {question.questionImage4 && (
          <img
            className="question12-img4"
            src={question.questionImage4}
            alt="Question"
          />
        )}
        {question.questionImage5 && (
          <img
            className="question12-img5"
            src={question.questionImage5}
            alt="Question"
          />
        )}
        {question.questionImage6 && (
          <img
            className="question12-img6"
            src={question.questionImage6}
            alt="Question"
          />
        )}
        {question.questionImage7 && (
          <img
            className="question12-img7"
            src={question.questionImage7}
            alt="Question"
          />
        )}
        {question.questionImage8 && (
          <img
            className="question12-img8"
            src={question.questionImage8}
            alt="Question"
          />
        )}
        {question.questionImage9 && (
          <img
            className="question12-img9"
            src={question.questionImage9}
            alt="Question"
          />
        )}
        {question.questionImage10 && (
          <img
            className="question12-img10"
            src={question.questionImage10}
            alt="Question"
          />
        )}
        {question.questionImage11 && (
          <img
            className="question12-img11"
            src={question.questionImage11}
            alt="Question"
          />
        )}

        <motion.h2
          className="question12-head"
          initial={{ opacity: 0, y: "-20%" }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: "-20%" }}
          transition={{ duration: 0.8 }}
        >
          {question.title}
        </motion.h2>

        <motion.div
          className="option12-container"
          initial={{ opacity: 0, x: "20%" }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: "20%" }}
          transition={{ duration: 1, delay: 0.3 }}
        >
          {question.options.map((option, index) => {
            const isChecked = userResponse[question.title] === option.label;

            return (
              <motion.label
                key={index}
                className={`radio12-option ${isChecked ? "checked" : ""}`}
                htmlFor={`option-${index}`}
                initial={{ opacity: 0, x: "20%" }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: "10%" }}
                transition={{
                  duration: 0.5,
                  delay: 0.2 + index * 0.2,
                }}
              >
                <input
                  type="radio"
                  id={`option-${index}`}
                  name={`question-${question.title}`}
                  value={option.label}
                  checked={isChecked}
                  onChange={() => onAnswer(question.title, option.label)}
                />
                <span className="radio12-label">{option.label}</span>
              </motion.label>
            );
          })}
        </motion.div>

        <motion.button
          type="submit"
          initial={{ opacity: 0, x: "20%" }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, y: "10%" }}
          transition={{ duration: 0.8, delay: 1 }}
          onClick={handleNext}
          disabled={!userResponse[question.title]}
        >
          Next Question
        </motion.button>
      </motion.div>
    </AnimatePresence>
  );
};

export default Question12;
